<template>
	<div v-loading="loadsing">
		<!-- 关联合并 --> 
		<div class="gl_list FlexWrap" v-if="datalist.length">
			<div class="shangji" v-for="(item, index) in datalist">
				<!-- 操作 -->
				<div class="operate_Area Flexalign">
					<div class="operate_icon" title="查看" @click="viewglInfo(item,index)">
						<i class="el-icon-view"></i>
					</div>
					<div class="operate_icon" title="编辑" @click="EditglInfo(item,index)">
						<i class="el-icon-edit-outline"></i>
					</div>
				</div>
				<div class="bianhao" v-if="types == 5" :title="item.ht_code">
					合同编号：{{ item.ht_code || '' }}
				</div>

				<div class="sj_name" v-if="types == 6" :title="item.hk_code">
					{{ item.hk_code || '' }}
				</div>
				<div class="sj_name" v-else-if="types == 4" :title="item.dd_code">
					{{ item.dd_code || '' }}
				</div>
				<div class="sj_name" v-else-if="types == 3" :title="item.bd_code">
					{{ item.bd_code || '' }}
				</div>
				<div class="sj_name" v-else :title="item.name">
					{{ item.name || '' }}
				</div>
				<div class="sj_qyname" v-if="item.customer_name">
					<div class="txt FlexRow">
						<img :src="urlhead + '/renz1.png'">
						{{ item.customer_name || '' }}
					</div>
				</div>
				<div class="sj_qyname" v-else-if="item.customer.name1">
					<div class="txt FlexRow">
						<img :src="urlhead + '/renz1.png'">
						{{ item.customer.name1 || '' }}
					</div>
				</div>
				<!-- 项目 -->
				<template v-if="types == 1">
					<div class="sj_state ">
						<div class="state state3" v-if="item.status == 1">
							进展中
						</div>
						<div class="state state1" v-else-if="item.status == 2">
							已完成
						</div>
						<div class="state state2" v-else>
							维护中
						</div>

						<div class="state state3" v-if="item.type_info">
							{{ item.type_info.name || '' }}
						</div>
						<!--  -->
						<div class="state state3" v-if="item.stage">
							{{ item.stage.name || '' }}
						</div>
					</div>
					<div class="sj_bottom">
						<div class="sj_text">
							负责人：{{ item.member_name || item.member.name || '' }}
						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								开始时间：
								<span v-if="item.start_time">
									{{ item.start_time || '' }}
								</span>
							</div>
							<div class="fonts FlexRow">
								结束时间：
								<span v-if="item.end_time">
									{{ item.end_time || '' }}
								</span>
							</div>
						</div>

					</div>

				</template>
				<!-- 商机 -->
				<template v-else-if="types == 2">
					<div class="sj_state ">
						<div class="state state1 " v-if="item.state == 1">
							已签约
						</div>
						<div class="state state2 " v-else>
							未签约
						</div>
						<div class="state state3">
							{{ item.status_stage || item.status.name || '' }}
						</div>
					</div>
					<div class="sj_bottom">
						<div class="sj_text">
							负责人：{{ item.member_name || item.member.name || '' }}
						</div>
						<div class="sj_btmfont">

							<div class="fonts FlexRow">
								商机预算：
								<span v-if="item.budget">
									￥{{ item.budget || 0 }}
								</span>
							</div>
							<div class="fonts FlexRow">
								预计签约时间：{{ item.signing_time || '' }}
							</div>
						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								创建时间：{{ item.create_time || '' }}
							</div>
							<div class="fonts FlexRow">
								最后跟进时间：{{ item.follow_time || '' }}
							</div>
						</div>
					</div>

				</template>
				<!-- 报价单 -->
				<template v-else-if="types == 3">
					<div class="sj_state ">
						<div class="state state3">
							{{item.status}}
						</div>
					</div>
					<div class="sj_bottom">
						<div class="sj_text"></div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								负责人：{{ item.member_name || '' }}
							</div>
							<div class="fonts FlexRow">
								报价单金额：
								<span v-if="item.quotation_price">
									￥{{ item.quotation_price || 0 }}
								</span>
							</div>
						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								制单时间：
								<span v-if="item.quotation_time">
									{{ item.quotation_time || '' }}
								</span>
							</div>

						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								收货地址：
								<span>
									{{ item.address || '' }}
								</span>
							</div>
						</div>
					</div>

				</template>
				<!-- 订单 -->
				<template v-else-if="types == 4">
					<div class="sj_state ">
						<div class="state state3">
							{{item.status}}
						</div>
					</div>
					<div class="sj_bottom">
						<div class="sj_text"></div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								负责人：{{ item.member_name || '' }}
							</div>
							<div class="fonts FlexRow">
								订单金额：
								<span v-if="item.order_price">
									￥{{ item.order_price || 0 }}
								</span>
							</div>
						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								制单时间：
								<span v-if="item.order_time">
									{{ item.order_time || '' }}
								</span>
							</div>

						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								收货地址：
								<span>
									{{ item.address || '' }}
								</span>
							</div>
						</div>
					</div>

				</template>
				<!-- 合同 -->
				<template v-else-if="types == 5">
					<div class="sj_bottom">
						<div class="sj_text">
							负责人：{{ item.member_name || item.member.name || '' }}
						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								签约日期：
								<span v-if="item.signing_time">
									{{ item.signing_time || '' }}
								</span>
							</div>
							<div class="fonts FlexRow">
								合同总金额：
								<span v-if="item.amount">
									￥{{ item.amount || 0 }}
								</span>
							</div>
						</div>
					</div>
				</template>
				<!-- 回款 -->
				<template v-else-if="types == 6">
					<div class="sj_state ">
						<div class="state state3" v-if="item.return_nature == 1">
							收款
						</div>
						<div class="state state3" v-else>
							预收款
						</div>
						<div class="state state3" v-if="item.audit_status == 0">
							待审核
						</div>
						<div class="state state1" v-else-if="item.audit_status == 1">
							已确认
						</div>
						<div class="state state2" v-else>
							拒绝
						</div>
					</div>
					<div class="sj_bottom">
						<div class="sj_text"></div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								负责人：{{ item.member_name || '' }}
							</div>
							<div class="fonts FlexRow">
								合同金额：
								<span v-if="item.amount">
									￥{{ item.amount || 0 }}
								</span>
							</div>
						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								回款日期：
								<span v-if="item.return_time">
									{{ item.return_time || '' }}
								</span>
							</div>
							<div class="fonts FlexRow">
								回款金额：
								<span v-if="item.huikuan">
									￥{{ item.huikuan || 0 }}
								</span>
							</div>
						</div>
						<div class="sj_btmfont">
							<div class="fonts FlexRow">
								合同源单：
								<span v-if="item.contract_name">
									{{ item.contract_name || '' }}
								</span>
							</div>
						</div>
					</div>

				</template>

			</div>
		</div>

		<!-- 没有数据 -->
		<template v-else>
			<nodata :show="true"></nodata>
		</template>
		<!--  -->




		<template v-if="types == 1">
			<!-- 项目 -->
			<div v-if="access_show">
				<projectlist :cid="cid" :glopertype="glopertype" @accessclose="accessclose"></projectlist>
			</div>
		</template>
		<template v-else-if="types == 2">
			<!-- 商机 -->
			<div v-if="access_show">
				<opportlist :cid="cid" :glopertype="glopertype" @accessclose="accessclose"></opportlist>
			</div>
		</template>

		<template v-else-if="types == 3">
			<!-- 报价单 -->
			<div v-if="access_show">
				<quotatlist :cid="cid" :glopertype="glopertype" @accessclose="accessclose"></quotatlist>
			</div>
		</template>
		<template v-else-if="types == 4">
			<!-- 订单 -->
			<div v-if="access_show">
				<orderlist :cid="cid" :glopertype="glopertype" @accessclose="accessclose"></orderlist>
			</div>
		</template>
		<template v-else-if="types == 5">
			<!-- 合同 -->
			<div v-if="access_show">
				<contractlist :cid="cid" :glopertype="glopertype" @accessclose="accessclose"></contractlist>
			</div>
		</template>
		<template v-else-if="types == 6">
			<!-- 回款 -->
			<div v-if="access_show">
				<lectionlist :cid="cid" :glopertype="glopertype" @accessclose="accessclose"></lectionlist>
			</div>
		</template>


	</div>
</template>

<script>
	import {
		xmde_list, // 项目
		gchance_list, // 商机
		get_contracTlist, // 合同
		hkl_list_return, // 回款
	} from 'network/hk_operset'
	import {
		get_order_list, // 订单
	} from "network/hk_order";
	import {
		get_quotation_list, // 报价单
	} from 'network/hk_quotation'
	import {
		formatCurrency,
	} from "network/defaults";
	import nodata from "@/components/content/publics/nodata.vue";
	// 项目
	import projectlist from "views/operate/childComps/projectlist/projectlist.vue";
	// 商机
	import opportlist from "views/operate/childComps/opportlist/opportlist.vue";
	// 报价单
	import quotatlist from "views/operate/childComps/quotation/pages/quotatlist.vue";
	// 订单
	import orderlist from "views/operate/childComps/order/pages/orderlist.vue";
	// 合同
	import contractlist from "views/operate/childComps/contract/contractlist.vue";
	// 回款
	import lectionlist from "views/operate/childComps/lection/lectionlist.vue";
	export default {
		name: "assocmerging",
		components: {
			nodata,

			projectlist,
			opportlist,
			quotatlist,
			orderlist,
			contractlist,
			lectionlist,
		},
		props: {
			// 1.项目  2.商机 3.报价单 4.订单 5.合同  6.回款
			types: {
				type: Number,
				default: 1,
			},

			chance_id: {
				type: Number,
				default: 0,
			},
			order_id: {
				type: Number,
				default: 0,
			},
			project_id: {
				type: Number,
				default: 0,
			},
			return_id: {
				type: Number,
				default: 0,
			},
			contract_id: {
				type: Number,
				default: 0,
			},
			customer_id: {
				type: Number,
				default: 0,
			},
			clist: {
				type: Array,
				default: () => {
					return []
				},
			},
			ishow: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',
				datalist: [],
				loadsing: true,

				currentinfo: '',
				viewShow: false,



				access_show: false,
				cid: 0,
				glopertype: 1,
			}
		},
		watch: {
			// 路由页面发生变化时
			$route(to, from) {
				if (to.path == '/customer/customer_list') {
					
					if (this.glopertype == 2) {
						this.routeChangeSet()
					}
				}
			},
			ishow() {
				this.Refresh()
			},
		},
		created() {
			this.initialization()
		},
		methods: {
			routeChangeSet() {
				// 报价单  订单
				if (this.types == 3 || this.types == 4) {
					this.accessclose()
				}
			},
			Refresh() {
				this.loadsing = true
				if (this.ishow) { // 当页面显示的时候
					this.initialization()
				}
			},
			accessclose() {
				this.access_show = false
				this.cid = 0
				if (this.glopertype == 2) {
					this.Refresh()
				}
			},
			// 查看
			viewglInfo(item, index) {
				// this.closeDrawer()
				this.glopertype = 1
				this.gotoRouter(item, 1)
			},
			// 编辑
			EditglInfo(item, index) {
				// this.closeDrawer()
				this.glopertype = 2
				this.gotoRouter(item, 2)
			},
			closeDrawer(){
				this.$emit('closeDrawer')
			},
			gotoRouter(item, glopertype) {
				let c_id = ''
				if (this.types == 1) { // 项目
					c_id = item.project_id || ''
				} else if (this.types == 2) { // 商机
					c_id = item.chance_id || ''
				} else if (this.types == 3) { // 报价单
					c_id = item.quotation_id || ''
				} else if (this.types == 4) { // 订单
					c_id = item.order_id || ''
				} else if (this.types == 5) { // 合同
					c_id = item.contract_id || ''
				} else if (this.types == 6) { // 回款
					c_id = item.return_id || ''
				}
				if (!c_id) return;
				this.access_show = true
				this.cid = c_id
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				setTimeout(() => {
					loading.close();
				}, 1000);
				
			},
			// 初始化
			initialization() {
				if (this.clist.length) { // 有已经获取的数据
					this.datalist = this.clist
					this.loadsing = false
				} else { // 没有数据,用id请求获取
					this.getLists()
				}
			},
			getLists() {
				let data = {
					sort_type: 1,
					pagesize: 999,
					is_recycle: 0,
				}
				if (this.types == 1) { // 项目
					this.getProjectList(data)
				} else if (this.types == 2) { // 商机
					this.getBusinessList(data)
				} else if (this.types == 3) { // 报价单
					this.getQuotationList(data)
				} else if (this.types == 4) { // 订单
					this.getOrderList(data)
				} else if (this.types == 5) { // 合同
					this.getContractList(data)
				} else if (this.types == 6) { // 回款
					this.getCollectList(data)
				}
			},
			// 项目
			getProjectList(data) {
				if (!this.customer_id && !this.chance_id && !this.contract_id) return;
				if (this.chance_id) {
					data.chance_id = this.chance_id
				}
				if (this.contract_id) {
					data.contract_id = this.contract_id
				}
				if (this.customer_id) {
					data.customer_id = this.customer_id
				}
				xmde_list(data).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result.data || ''
						this.handle_data1(obj)
					}
				})
			},
			// 商机
			getBusinessList(data) {
				if (!this.customer_id) return;
				if (this.customer_id) {
					data.customer_id = this.customer_id
				}
				gchance_list(data).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result.data || ''
						this.handle_data2(obj)
					}
				})
			},
			// 报价单
			getQuotationList(data) {
				if (!this.customer_id) return;
				if (this.customer_id) {
					data.customer_id = this.customer_id
				}
				get_quotation_list(data).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result.data || ''
						this.handle_data3(obj)
					}
				})
			},
			// 订单
			getOrderList(data) {
				if (!this.customer_id) return;
				if (this.customer_id) {
					data.customer_id = this.customer_id
				}
				get_order_list(data).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result.data || ''
						this.handle_data4(obj)
					}
				})
			},
			// 合同
			getContractList(data) {
				if (!this.customer_id && !this.project_id && !this.contract_id && !this.return_id) return;
				if (this.chance_id) {
					data.chance_id = this.chance_id
				}
				if (this.return_id) {
					data.return_id = this.return_id
				}
				if (this.project_id) {
					data.project_id = this.project_id
				}
				if (this.customer_id) {
					data.customer_id = this.customer_id
				}
				get_contracTlist(data).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result.data || ''
						this.handle_data5(obj)
					}
				})
			},
			// 回款
			getCollectList(data) {
				if (!this.customer_id && !this.order_id && !this.contract_id) return;
				if (this.contract_id) {
					data.contract_id = this.contract_id
				}
				if (this.order_id) {
					data.order_id = this.order_id
				}
				if (this.customer_id) {
					data.customer_id = this.customer_id
				}
				hkl_list_return(data).then((res) => {
					if (this.$handlereq(res)) {
						let obj = res.result.data || ''
						this.handle_data6(obj)
					}
				})
			},
			// 
			return_signInfo(strInfo, field) {
				let res = ''
				let newArr = this.$retJSONArr(strInfo) || []
				if (newArr.length) {
					let index = newArr.findIndex(v => v.field_sign == field || v.field == field)
					if (index != -1) {
						res = newArr[index].content
					}
				}
				return res;
			},
			// 处理数据 项目
			handle_data1(data) {
				for (let item of data) {
					item.start_time = item.start_time ? item.start_time.slice(0, 10) : '';
					item.end_time = item.end_time ? item.end_time.slice(0, 10) : '';
				}
				this.datalist = data || [];
				this.loadsing = false
				let len = this.datalist.length || 0;
				this.$emit('retnum', len)
			},
			// 处理数据 商机
			handle_data2(data) {
				for (let item of data) {
					item.budget = formatCurrency(this.return_signInfo(item.business_info, '商机预算'))
					item.signing_time = item.signing_time ? item.signing_time.slice(0, 10) : '';
					item.create_time = item.create_time ? item.create_time.slice(0, 10) : '';
					item.follow_time = item.follow_time ? item.follow_time.slice(0, 10) : '';
				}
				this.datalist = data || [];
				this.loadsing = false
				let len = this.datalist.length || 0;
				this.$emit('retnum', len)
			},
			// 处理数据 报价单
			handle_data3(data) {
				for (let item of data) {
					let c_addre = this.return_signInfo(item.quotation_info, '收货地址')
					item.address = c_addre.area_txt1 + c_addre.area_txt2 + c_addre.area_txt3 + c_addre.address
					item.quotation_price = formatCurrency(item.quotation_price * 1)
				}
				this.datalist = data || [];
				this.loadsing = false
				let len = this.datalist.length || 0;
				this.$emit('retnum', len)
			},
			// 处理数据 订单
			handle_data4(data) {
				for (let item of data) {
					let c_addre = this.return_signInfo(item.order_info, '收货地址')
					item.address = c_addre.area_txt1 + c_addre.area_txt2 + c_addre.area_txt3 + c_addre.address
					item.order_price = formatCurrency(item.order_price * 1)
				}
				this.datalist = data || [];
				this.loadsing = false
				let len = this.datalist.length || 0;
				this.$emit('retnum', len)
			},
			// 处理数据 合同
			handle_data5(data) {
				for (let item of data) {
					item.amount = formatCurrency(this.return_signInfo(item.contract_info, '合同总金额'))
					item.signing_time = item.signing_time ? item.signing_time.slice(0, 10) : '';
				}
				this.datalist = data || [];
				this.loadsing = false
				let len = this.datalist.length || 0;
				this.$emit('retnum', len)
			},
			// 处理数据 回款
			handle_data6(data) {
				for (let item of data) {
					item.amount = formatCurrency(this.return_signInfo(item.return_info, '合同金额'))
					item.huikuan = formatCurrency(this.return_signInfo(item.return_info, '回款金额'))
					item.return_time = item.return_time ? item.return_time.slice(0, 10) : '';
				}
				this.datalist = data || [];
				this.loadsing = false
				let len = this.datalist.length || 0;
				this.$emit('retnum', len)
			},
		}
	}
</script>

<style scoped lang="scss">
	@import "./assoc.scss";
</style>